import clsx from 'clsx'
import { ReactNode, useMemo } from 'react'

interface ButtonItemProps<T> {
  children: ReactNode
  value: T
  selected?: boolean
  selectedClassName?: string
  unselectedClassName?: string
  className?: string
  onClick?: (text: T) => void
  type?: 'normal' | 'text'
}
const ButtonItem = <T extends string>({
  children,
  value,
  selected,
  onClick,
  className,
  selectedClassName,
  unselectedClassName,
  type = 'normal',
}: ButtonItemProps<T>) => {
  const commonStyle = useMemo(() => {
    switch (type) {
      case 'normal':
        return 'rounded-full'
      case 'text':
      default:
        return ''
    }
  }, [type])

  return (
    <button
      className={clsx(
        'flex items-center border border-transparent transition duration-500',
        className || 'px-[18px] py-[9px] text-sm',
        commonStyle,
        selected
          ? selectedClassName ||
              '!border-white/20 bg-secondary-bg text-white shadow-[0_2px_4px_0_rgba(255,255,255,0.05)]'
          : unselectedClassName || 'text-[#847379]'
      )}
      onClick={() => onClick?.(value)}
    >
      {children}
    </button>
  )
}

export default ButtonItem
